<template>
<div class="content-class">
	<v-tabs v-model="active" color="black" dark slider-color="primary">
		<v-tab :key="'variable'" ripple>Variable</v-tab>
		<v-tab :key="'logs'" ripple>Logs</v-tab>

		<v-tab-item :key="'subBot'">
			<bot-variable-form v-model="document">
			</bot-variable-form>

			<v-btn :disabled="loading" color="error" @click="deleteVariable()">
				<v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
				Supprimer
			</v-btn>

		</v-tab-item>

		<v-tab-item :key="'Logs'">
			<log-list :url="'logs?filter=references.reference:$eq:botVariables;references.referenceId:$eq:'+$route.params.vairableId">
			</log-list>
		</v-tab-item>
	</v-tabs>
</div>
</template>
<script>
import BotVariableForm from '../../components/botVariables/botVariable.form'
import LogList from '../../components/logs/log.list.vue'

import { ERROR, SUCCESS } from '../../variables'

export default {
	components: { BotVariableForm, LogList },
	data() {
		return {
			loading: false,
			active: null,
			document: null
		}
	},
	methods: {
		deleteVariable() {
			this.axios.delete('botVariables/' + this.$route.params.vairableId)
				.then(response => {
					this.$router.push({ name: 'UsersList', params: { botId: this.document.bot } })
					this.$store.dispatch(SUCCESS, 'Vairable supprimé')
				})
				.catch((err) => {
					this.$store.dispatch(ERROR, err)
				})
		}
	},
	mounted() {
		this.axios
			.get('botVariables/' + this.$route.params.vairableId)
			.then(response => {
				this.document = response.data
			})
			.catch((err) => {
				this.$store.dispatch(ERROR, err)
			})
	}

}
</script>
<style lang="scss">
.content-class {
    width: 100%;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/botVariables/botVariable.detail.vue